<template>
  <div>
    <!-- <div class="commonBg companyBg">
			<img :src="banner.pic" alt="">
			<div class="title">
				<span>{{banner.title}}</span>
			</div>
		</div> -->
    <div class="bannerVideo" @click="topVideoPause()">
      <!-- <div :class="topVideoShow?'playBtn':'showNo'" @click.stop="topVideoPlay()">
        <div class="playBox">
					<div class="circle2"></div>
					<div class="circle">
						<i class="el-icon-caret-right"></i>
					</div>
				</div>
      </div> -->
      <div
        :class="topVideoShow ? 'play' : 'showNo'"
        @click.stop="topVideoPlay()"
      >
        <i class="el-icon-caret-right"></i>
      </div>
      <video
        width="auto"
        :src="videoLink"
        id="whVideo"
        loop="loop"
        x5-video-player-type="h5-page"
        webkit-playsinline
        x5-playsinline
        playsinline
        muted
      >
        <source :src="videoLink" type="video/mp4" />
        <source :src="videoLink" type="video/webm" />
        <source :src="videoLink" type="video/ogg" />
      </video>
    </div>
    <div :id="maxscrollTop ? 'commonGoTopNav' : ''" class="navBox">
      <div class="centerBox">
        <div class="commonNavBox">
          <div
            :class="tabOpt == index ? 'tabList tabOpt' : 'tabList'"
            v-for="(item, index) in tabList"
            :key="index"
            @click="handleClick(item, index)"
          >
            <div class="text">{{ item.catname }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="module">
      <div class="videoBox">
        <div class="videoList" v-for="(item, index) in videoList" :key="index">
          <img :src="$imgUrl.imgUrl(item.thumb)" alt="" />
          <div class="play" @click.stop="videoPlay(item.file)">
            <i class="el-icon-caret-right"></i>
          </div>
          <div class="bottom_text">{{ item.text }}</div>
        </div>
        <div class="pagination">
          <el-pagination background layout="prev, pager, next" :total="total" :page-size='6' @current-change="changPage" >
        </el-pagination>
        总共 {{total}}
        </div>
      </div>
    </div>
    <div class="dialog" v-show="videoDialog">
      <div class="mask"></div>
      <div class="dialog_content">
        <i class="el-icon-close dialogVideoClose" @click="videoClose()"></i>
        <video
          width="auto"
          
          controls
          id="videoBig"
          ref="videoBig"
          loop="loop"
          x5-video-player-type="h5-page"
          webkit-playsinline
          autoplay
          x5-playsinline
          playsinline
          muted
        >
        </video>
        <div class="share" v-if="false">
          <div class="shareTitle">
            <img class="shareIcon" src="../../src/img/share.png" alt="">
            <div class="shareText">Share To:</div>
          </div>
          <div class="iconBtnBox">
            <div class="iconBtn">
              <!-- <a :href="item.url" v-for="(item,index) in iconList" :key="index"  target="_blank"> 
                <img :src="item.img" alt="">
              </a> -->
              <a :href="item.url" v-for="(item,index) in iconList" :key="index"  target="_blank"> 
                <img :src="item.img" alt="">
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
</style>
<script>
import * as axios from "../../src/axios/api.js";
import imgUrl from "../../src/utils/imgUrl.js";
export default {
  data() {
    return {
      total:0,
      currentPage:1,
      catid:'',
      topVideoShow: true,
      videoDialog: false,
      videoLink:'',
      videoList: [
        
      ],
      tabOpt: 2,
      maxscrollTop: false,
      tabList: [
        
      ],
      iconList:[],
			iconList2:[
				{
          url:'',
					img:require('../../src/img/en_douyin_icon.png'),
				},
				{	
          url:'',		
					img:require('../../src/img/youtube.png'),
        }	
			],
    };
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        //this.getAnchor(val.query.anchor);
      },
      // 深度观察监听
      deep: true,
    },
  },
  created() {
    //视频中心
    let id = this.$route.query.id;
    this.getVideoList(id);
    this.catid=id;
    this.iconList=JSON.parse(JSON.stringify(this.iconList2));
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    topVideoPlay() {
      var that = this;
      var video = document.getElementById("whVideo");
      that.topVideoShow = false;
      video.play();
    },
    topVideoPause() {
      var that = this;
      var video = document.getElementById("whVideo");
      that.topVideoShow = true;
      video.pause();
    },
    videoPlay(url) {
      var that = this;
      that.videoDialog = true;
      var video = document.getElementById("videoBig");
      video.src = imgUrl.imgUrl(url);
    },
    videoClose() {
      var that = this;
      that.videoDialog = false;
      var video = document.getElementById("videoBig");
      video.pause();
      video.src = "";
    },
    // iconImgChang(item,index){
		// 	var that=this
		// 	item.img=that.iconList2[index].img_
		// },
		// iconImgReduction(item,index){
		// 	var that=this
		// 	item.img=that.iconList2[index].img
		// },
    start(e) {
      e.preventDefault();
    },
    getVideoList(catid) {
      var page=this.currentPage
      axios.get("/api/news/list",{catid:catid,page:page}).then((res) => {
        if (res.code == 1) {
          this.tabList=res.data.category;
          this.videoList=res.data.list.data;
          this.videoLink=imgUrl.imgUrl(res.data.video);
          this.total=res.data.list.total
        }
      });
    },
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 1004) {
        this.maxscrollTop = true;
      } else {
        this.maxscrollTop = false;
      }
    },
    changPage(val){
      this.currentPage=val;
      this.getVideoList(this.catid);
    },
    getUrl(item){
      this.$router.push({ name: "newListDetail", query: {id:item.id,catid:item.catid}});
    },
    handleClick(item, index) {
      console.log(item)
      var that = this;
      var name= item.url.replace("/","");
      this.$router.push({ name: name, query: {id:item.id} });
    },
  },
};
</script>
<style scoped>
.showNo {
  display: none;
}
.centerBox {
  width: 75vw;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
}
.bannerVideo {
  width: 100%;
  height: 960px;
  position: relative;
}
.bannerVideo video {
  width: 100%;
  object-fit: fill;
  height: 100%;
}
/* .bannerVideo .playBtn{width: 84px;height: 84px; position: absolute;top:50%;left: 50%;margin-top:-42px;margin-left: -42px;z-index: 99;}
.bannerVideo .playBox .circle{border-radius: 50%;height: 70px;width: 70px;background: #FFF;text-align: center;position: absolute;left: 50%;top:50%;margin-top:-35px;margin-left: -35px;}
.bannerVideo .playBox .circle i{font-size: 28px;color: #666;line-height: 70px;}
.bannerVideo .playBox{position: relative;width: 100%;height: 100%;}
.bannerVideo .playBtn .playBox:hover .circle2{display: block;position: absolute;content: '';width: 84px;height: 84px;border-radius: 50%;background: #FFF;-webkit-mask: radial-gradient(transparent, transparent 39px, #000 40px);} */
.play:after {
  content: "";
  position: absolute;
  width: 94%;
  height: 94%;
  top: 0;
  left: 0;
  border-radius: 50%;
  opacity: 0;
  background-color: transparent;
  border: 2px solid #fff;
  z-index: -1;
  transition: opacity 0.3s, transform 0.5s;
}
.play {
  color: #666;
  display: inline-block;
  width: 70px;
  height: 70px;
  border-radius: 50%;
  line-height: 70px;
  text-align: center;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 10;
  background-color: #fff;
  font-size: 36px;
  transition: all 0.3s ease-in-out;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
}
.play:hover:after {
  opacity: 1;
  transform: scale(1.2);
  -webkit-transform: scale(1.2);
  -moz-transform: scale(1.2);
  -o-transform: scale(1.2);
  -ms-transform: scale(1.2);
}

.fourColumns {
  display: flex;
}
.fourColumns .listBox {
  width: 25%;
}
.module {
  padding-top: 120px;
  display: flex;
  justify-content: center;
  text-align: center;
}
.module .moduleTitle {
  margin-bottom: 48px;
  font-size: 36px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #009144;
}
.module .moduleContent {
  width: 73vw;
}
.videoBox {
  display: flex;
  flex-wrap: wrap;
  width: 75vw;
}
.videoList {
  margin: 0 11px;
  margin-bottom: 22px;
  width: 452px;
  height: 300px;
  position: relative;
  background: #666;
}
.videoList img {
  width: 100%;
  height: 100%;
}
.videoList .bottom_text {
  position: absolute;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  font-size: 18px;
  font-weight: 400;
  color: #fcfcfe;
  line-height: 42px;
  width: 100%;
}
.pagination {
  margin-top: 48px;
  margin-bottom: 90px;
}
.dialog {
  position: fixed;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  pointer-events: none;
  visibility: visible;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 10000;
}
.dialog .mask {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: absolute;
  z-index: -1;
  background: rgba(0, 0, 0, 0.8);
  -webkit-transition: opacity 0.3s;
  transition: opacity 0.3s;
  transition-duration: 0.3s;
  -webkit-backface-visibility: hidden;
}
.dialog .dialog_content {
  position: relative;
  width: auto;
  max-width: inherit;
  min-width: inherit;
  padding: 1em;
  background: #fff;
  -webkit-animation-duration: 0.5s;
  animation-duration: 0.5s;
  animation-timing-function: ease;
  -webkit-animation-name: anim-open-6;
  animation-name: anim-open-6;
  opacity: 1;
  pointer-events: auto;
}
.dialog .dialog_content video {
  width: 70vw;
  opacity: 1;
  object-fit: cover;
}
.dialogVideoClose {
  position: absolute;
  font-size: 29px;
  right: -20px;
  color: #e6e6e6;
  top: -4px;
  right: -46px;
}
.share{position: absolute;bottom: -80px;right: 0;}
.shareTitle{display: inline-block;vertical-align: middle;}
.shareIcon{margin-top: -3px;width: 18px;height: 21px;display: inline-block;vertical-align: middle;}
.shareText{margin-left: 6px;margin-right: 22px; display: inline-block;font-size: 16px;font-family: Microsoft YaHei;font-weight: 400;color: #CCC;}
.iconBtnBox{display: inline-block;vertical-align: middle;}
.iconBtnBox .iconBtn{display: flex;}
.iconBtnBox .iconBtn a{margin-right: 14px;}
.iconBtnBox .iconBtn img{width: 38px;height: 38px;}
</style>